<template>
  <div
    :class="{
      'recommend-doctor': doctorInfo.is_recommend,
      'card-warp-content': true,
    }"
    @click="onCard"
  >
    <img
      v-if="doctorInfo.is_recommend"
      class="recommend-expert"
      src="https://staff.chunyu.mobi/@/media/images/2022/09/01/d68f/6e35a1985055_w216_h57_.png"
      alt="推荐专家"
    />
    <div class="doctor-base">
      <span class="avatar">
        <img :src="doctorInfo.image" class="avatar" alt="头像" />
      </span>
      <div class="doctor-base-message">
        <div class="doctor-basic-info-section">
          <div class="text-holder">
            <span class="doctor-name">{{ slicedName }}</span>
            <span class="col-line" />
            <span class="title">{{ doctorInfo.title }}</span>
            <span class="clinc">{{ doctorInfo.clinic_name }}</span>
          </div>
          <div v-if="doctorInfo.can_pres" class="doctor-info-tags">
            可开处方
          </div>
        </div>
        <div class="hospital-name-content">
          <div class="hospital-name">
            {{ doctorInfo.hospital_name }}
          </div>
          <div v-if="doctorInfo.is_3a_hospital" class="hospital-tag is-3a">
            三甲
          </div>
          <div
            v-if="doctorInfo.is_top_100_hospital"
            class="hospital-tag top-100"
          >
            {{ doctorInfo.hospital_tag_text }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="doctorInfo.new_tags && doctorInfo.new_tags.length"
      class="tag-list"
    >
      <div
        v-for="(item, loops) in doctorInfo.new_tags"
        :key="loops"
        :class="{
          'line-hight-tag': item.highlight,
          'primary-tag': !item.highlight,
        }"
      >
        <img v-if="item.icon" :src="item.icon" alt="图标" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="good-at" v-html="doctorInfo.good_at" />
    <div
      v-if="doctorInfo.qa_tags && doctorInfo.qa_tags.length"
      class="qa-tags-section"
    >
      <div
        v-for="(tag, loop) in doctorInfo.qa_tags"
        :key="loop"
        class="single-qa-tag"
      >
        {{ tag }}
      </div>
    </div>
    <div v-if="isNot101" class="doc-evaluate">
      <div>
        好评<span>{{ doctorInfo.good_rate }}</span>
        <img
          src="https://staff.chunyu.mobi/@/media/images/2021/12/26/6b6e/cf85b3e474b3_w30_h30_.png"
          alt="好评"
        />
      </div>
      <div>
        接诊量<span>{{ doctorInfo.reply_num }}</span>
      </div>
      <div>
        同行认可<span>{{ doctorInfo.solution_score_desc }}</span>
      </div>
    </div>
    <div v-else class="doc-evaluate">
      <div v-for="(item, i) in doctorInfo.service_data_list" :key="i">
        {{ item.name }}<span>{{ item.descrip }}</span>
        <img v-if="item.icon" :src="item.icon" alt="好评" />
      </div>
    </div>
    <div class="doc-out-call-type">
      <div class="doc-out-call-type-left">
        <div
          v-for="(item, idx) in doctorInfo.service_list"
          :key="idx"
          class="out-call-item"
        >
          {{
            item.price
              ? `${item.service_type_verbose}￥${item.price}`
              : item.service_type_verbose
          }}
          <img
            v-if="item.show_badge && item.badge_text === '需预约'"
            src="https://staff.chunyu.mobi/@/media/images/2022/01/17/a647/ab27b94021a6_w111_h54_.png"
            alt="需预约"
            class="out-call-icon"
          />
          <img
            v-if="item.show_badge && item.badge_text === '直拨'"
            src="https://staff.chunyu.mobi/@/media/images/2021/12/26/5a2b/b2df270dd391_w84_h57_.png"
            alt="直拨"
            class="out-call-icon"
          />
        </div>
        <div v-if="doctorInfo.is_rest" class="out-call-item">
          预约咨询
        </div>
      </div>
      <div v-if="doctorInfo.ad_tag" class="tag">
        <!-- <img
          v-if="doctorInfo.ad_tag.icon"
          :src="doctorInfo.ad_tag.icon"
          alt="广告"
        /> -->
        <span>{{ doctorInfo.ad_tag.name }}</span>
      </div>
    </div>
    <div v-if="doctorInfo.comment_tag" class="assess-section">
      <div class="line-wrapper">
        {{ doctorInfo.comment_tag }}
      </div>
    </div>
  </div>
</template>
<script>
import * as cyDetect from '@cy/detect';

export default {
  name: 'DoctorCard',
  props: {
    doctorInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => {
    return {
      isNot101:
        cyDetect.isFromCY() && !cyDetect.isGreaterAppVersion('10.1.0', true),
    };
  },
  computed: {
    slicedName() {
      if (this.doctorInfo.name && this.doctorInfo.name.length > 4) {
        return `${this.doctorInfo.name.slice(0, 4)}...`;
      }
      return this.doctorInfo.name;
    },
  },
  created() {
    this.doctorInfo.good_at =
      this.doctorInfo.good_at &&
      this.doctorInfo.good_at.replace(
        'color:#666666',
        'color:#666666; line-height: 0.507rem;'
      );
  },
  methods: {
    onCard() {
      this.$emit('click', this.doctorInfo, this.index);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.card-warp-content {
  position: relative;
  margin: 0 rem(10) rem(10) rem(10);
  padding: rem(15) rem(10);
  overflow-y: visible;
  background: #fff;
  border-radius: rem(4);
  &.recommend-doctor {
    background-image: url('https://staff.chunyu.mobi/@/media/images/2022/09/01/454f/81a4a5c7aa82_w1065_h240_.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    border-top: 1px solid white;
  }
  .recommend-expert {
    position: absolute;
    top: rem(-3);
    right: 0;
    width: rem(72);
    height: rem(19);
  }
  .doctor-base {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    .avatar {
      display: inline-block;
      flex: 0 0 rem(50);
      height: rem(50);
      border: rem(0.2) solid #e7e7e7;
      border-radius: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }
    .doctor-base-message {
      display: flex;
      flex-flow: column nowrap;
      flex-grow: 1;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      margin-left: rem(8);
      overflow: hidden;
    }
  }
  .doctor-basic-info-section {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .text-holder {
      width: auto;
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      .col-line {
        display: inline-block;
        width: rem(0.5);
        height: rem(10);
        margin-right: rem(5);
        background: #e0e0e0;
      }
      span {
        margin-right: rem(8);
        color: #323232;
        font-size: rem(13);
        line-height: rem(13);
      }
      .doctor-name {
        margin-right: rem(5);
        font-weight: 500;
        font-size: rem(16);
        line-height: rem(16);
        letter-spacing: 0;
      }
    }
    .doctor-info-tags {
      flex-shrink: 0;
      height: rem(16);
      margin-left: rem(5);
      padding: 0 rem(4);
      color: #2883de;
      font-size: rem(12);
      line-height: rem(16);
      background: #f2f8fd;
      border-radius: rem(2);
    }
    .top-100 {
      flex-shrink: 0;
      height: rem(16);
      margin-left: auto;
      padding: 0 rem(4);
      color: #91632f;
      font-size: rem(12);
      line-height: rem(16);
      background: #f7e9d2;
      border-radius: rem(2);
    }
  }
  .hospital-name-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: rem(5);
    color: #323232;
    font-size: rem(13);
    .hospital-name {
      max-width: rem(234);
      margin-right: rem(5);
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
      text-overflow: ellipsis;
    }
    .hospital-tag {
      flex-shrink: 0;
      height: rem(16);
      padding: 0 rem(4);
      font-size: rem(12);
      line-height: rem(16);
      border-radius: rem(2);
      &.is-3a {
        color: white;
        background: #1cc381;
      }
      &.top-100 {
        margin-left: rem(5);
        color: #91632f;
        background: #f7e9d2;
      }
    }
  }
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    height: rem(22);
    margin-top: rem(10);
    overflow: hidden;
    div {
      display: flex;
      align-items: center;
      height: rem(22);
      margin-right: rem(5);
      padding: rem(3) rem(8);
      font-size: rem(12);
      img {
        width: rem(12);
        margin-right: rem(2);
        // transform: translateY(rem(2));
      }
    }
    .line-hight-tag {
      color: #91632f;
      background: #f7e9d2;
      border-radius: rem(2);
    }
    .primary-tag {
      color: #308ce8;
      background: rgba(48, 140, 232, 0.06);
      border-radius: rem(2);
    }
  }
  .good-at {
    display: -webkit-box;
    box-sizing: border-box;
    max-height: rem(36);
    margin-top: rem(10);
    overflow: hidden;
    color: #666;
    font-size: rem(13);
    line-height: rem(17);
    letter-spacing: 0;
    text-align: left;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    span {
      display: inline-block;
      height: 100%;
    }
  }
  .doc-evaluate {
    display: flex;
    align-items: center;
    margin-top: rem(10);
    div {
      margin-right: rem(20);
      color: #666;
      font-size: rem(13);
      img {
        width: rem(12);
        height: rem(12);
        margin-left: rem(3);
      }
    }
    span {
      margin-left: rem(3);
      color: #323232;
      font-weight: 500;
    }
  }
  .doc-out-call-type {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: rem(15);
    .doc-out-call-type-left {
      display: flex;
      flex: 1 1 auto;
      flex-wrap: nowrap;
      align-items: center;
      white-space: nowrap;
      .out-call-item {
        position: relative;
        box-sizing: border-box;
        height: rem(25);
        padding: 0 rem(8);
        color: #39d167;
        font-size: rem(13);
        line-height: 0.7rem;
        background: #fff;
        box-shadow: 0 4px 0 0 #fff;
        @include border-1px(#39d167, 30);

        .out-call-icon {
          position: absolute;
          top: rem(-10);
          right: rem(-6);
          height: rem(18);
        }
      }
      div + div {
        margin-left: rem(5);
      }
      .doc-out-call-type-left-price {
        margin-left: rem(-5);
      }
    }
    .tag {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: rem(3) rem(6);
      color: #ff7751;
      font-size: rem(12);
      border: 0.5px solid #ff7751;
      border-radius: 2px;
      img {
        height: rem(12);
        margin-right: rem(2);
      }
    }
  }
  .qa-tags-section {
    display: flex;
    flex-flow: row wrap;
    height: rem(20);
    margin-top: rem(10);
    overflow: hidden;
    .single-qa-tag {
      height: rem(20);
      margin-left: rem(5);
      padding: 0 rem(6);
      color: #666;
      font-size: rem(12);
      line-height: rem(20);
      background: #f7f7f7;
      border-radius: rem(2);
      &:first-of-type {
        margin-left: 0;
      }
    }
  }
  .assess-section {
    box-sizing: border-box;
    width: 100%;
    margin-top: rem(12);
    padding: rem(5) rem(6);
    text-align: left;
    background: #f9f9f9;
    background-image: url('https://resource.chunyu.mobi/@/media/images/2022/08/25/18fc/e2e643e35e23_w42_h36_.png');
    background-repeat: no-repeat;
    background-position: top left rem(5);
    background-size: rem(12) rem(12);
    border-radius: rem(2);
    .line-wrapper {
      display: block;
      overflow: hidden;
      color: #666;
      font-size: rem(12);
      line-height: 1;
      white-space: nowrap;
      text-align: left;
      text-overflow: ellipsis;
      word-break: break-all;
      background: #f9f9f9;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
